import * as React from 'react'
import BertholdTitle from 'src/components/atoms/bertholdTitle'

import * as GlobalStyles from 'src/styles/global.module.scss'
import CustomLink from 'src/utils/customLink'
import { PrismicLinkType } from 'src/typings/generated/graphql'
import LogoRepeat from 'src/images/svgs/LogoRepeat.svg'
import { generateRandomId } from 'src/utils/domHelper'
import * as Styles from './logoCta.module.scss'

export enum LogoCTABackgroundColor {
  red = 'red',
  black = 'black',
}

export type LogoCTAContent = {
  anchor?: string
  buttonLink?: PrismicLinkType
  buttonText?: string
  headline?: string
  hasTrademark?: boolean
  backgroundColor?: string
}
interface Props {
  content: LogoCTAContent
}

const LogoCTA = ({ content }: Props) => {
  const {
    anchor = generateRandomId(),
    buttonLink,
    buttonText = '',
    headline = '',
    hasTrademark = false,
    backgroundColor = LogoCTABackgroundColor.red,
  } = content

  let sectionClass = Styles.logoCta

  const backgroundColorFormatted = backgroundColor.toLowerCase()
  if (backgroundColorFormatted === LogoCTABackgroundColor.black) {
    sectionClass += ` ${Styles.blackBackground}`
  }

  return (
    <section id={anchor} className={sectionClass}>
      <div className={Styles.copy}>
        <h3 className={Styles.headline}>
          {BertholdTitle({ text: headline })}
          {hasTrademark && <sup>®</sup>}
        </h3>
        <div className={Styles.button}>
          {buttonLink?.url && (
            <CustomLink
              className={GlobalStyles.whiteGhostButtonResponsive}
              link={buttonLink}
            >
              {buttonText}
            </CustomLink>
          )}
        </div>
      </div>
      <div className={Styles.logo}>
        <LogoRepeat />
      </div>
    </section>
  )
}

export default LogoCTA
